<template>
  <div class="header">
    <!-- <div class="title">无涯云平台</div> -->
    <div class="img-box">
      <img src="../assets/img/Logo.png" alt="无涯智能官网--无涯智能集研发、生产、销售于一体，主营无线联网通讯模块和设备" border="0" />
      <h2 style="color: rgb(233, 255, 255); letter-spacing: 4px; float:left;font-weight: 700;font-size: 19px;margin:0">
        无涯云管理后台
      </h2>
    </div>
    <!-- 右侧内容 -->
    <div class="right-box">
      <!-- <div class="content-box">
        <img src="../assets/img/service.png">
        <a
          href="https://www.hi-wooya.com/ServiceSupport"
          target="_blank"
        >
          <div>服务支持</div>
        </a>
      </div> -->
      <div class="content-box-header">
        <img src="../assets/img/earth.png">
        <div v-if="langy === 'en'" @click="swichtqy('zh-CN')" style="cursor: pointer;">Englisth</div>
        <div v-if="langy === 'zh-CN'" @click="swichtqy('en')" style="cursor: pointer;">中文</div>
      </div>
      <div class="full-box">
        <div class="full iconfont" @click="screen()" :class="this.full ? 'icon-tuichuquanping' : 'icon-quanping'"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      noticeshow: false,
      user: '',
      head: '',
      imgsrc: '',
      full: false,
      langy: 'zh-CN',
    }
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem('user'))
    //this.head = this.user.head
    //this.imgsrc = 'https://cloud.hi-wooya.com/headimg/' + this.head
    // 读取存储的语言设置
    const savedLang = localStorage.getItem('lang')
    if (savedLang) {
      this.$i18n.locale = savedLang
    }
  },
  methods: {
    noticeenter() {
      this.noticeshow = true
    },
    //中英文切换
    swichtqy(val) {
      this.langy = val;
      this.$i18n.locale = val       // 切换语言
      localStorage.setItem('lang', val)  // 持久化存储（可选）
    },
    // 跳转页面
    page(path) {
      this.$js.openpages(path);
    },
    noticeleave() {
      this.noticeshow = false
    },
    logout() {
      this.$js.openpages('/');
      sessionStorage.clear()
    },
    screen() {
      let full = document.fullscreenElement
      this.full = full
      if (!this.full) {
        //利用requestFullscreen方法实现全屏
        document.documentElement.requestFullscreen()
      } else {
        //退出全屏
        document.exitFullscreen()
      }
      this.full = !this.full
    }
  }
}
</script>
<style scoped>
.header {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #002539;
}

.title {
  position: fixed;
  height: 50px;
  line-height: 50px;
  /* left: 50%; */
  left: calc((100% - 210px) / 2 + 210px);
  color: #97a8be;
  transform: translate(-50%, 0);
}

.img-box {
  height: 60px;
  line-height: 60px;
}

.img-box img {
  margin-right: 10px;
  width: 18px;
  height: 19px;
  float: left;
  margin-top: 21px;
  margin-left: 20px;
}

.right-box {
  display: flex;
  margin-right: 10px;
}

.content-box-header {
  position: relative;
  display: flex;
  height: 50px;
  align-items: center;
  padding: 0px 10px;
}

.full-box {
  position: relative;
  display: flex;
  height: 50px;
  align-items: center;
  padding: 0px 10px;
  padding-left: 8px;
}

.notice-box {
  background-color: white;
  position: absolute;
  top: 50px;
  right: 0px;
  padding: 10px 0;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.full {
  /* width: 18px;
  height: 18px; */
  font-size: 14px;
  cursor: pointer;
  color: #fff;
}

.notice-son {
  width: 100px;
  height: 36px;
  line-height: 36px !important;
  text-align: center;
  color: #333333 !important;
  cursor: pointer;
}

.notice-son:hover {
  color: #012f55 !important;
}

.triangle {
  top: 40px;
  right: 30px;
  position: absolute;
  border-top: 5px solid transparent;
  border-bottom: 5px solid white;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}

.content-box-header img {
  width: 18px;
  height: 18px;
  margin-right: 5px;
}

.content-box-header div {
  font-size: 14px;
  color: #fff;
  line-height: 50px;
}
</style>